import { Injectable } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';

@Injectable({ providedIn: 'root' })
export class SystemLogRegisterSessionStorageService {
   private readonly systemLogOrderingOptionsStorageKey = '__ndt-system-log-ordering-options';

   clearAll(): void {
      localStorage.clear();
   }

   removeSystemLogOrderingOptions(): void {
      localStorage.removeItem(this.systemLogOrderingOptionsStorageKey);
   }

   getSystemLogOrderingOptions() {
      const localData = localStorage.getItem(this.systemLogOrderingOptionsStorageKey);
      if (localData) {
         return JSON.parse(localData);
      }
      return null;
   }

   setSystemLogOrderingOptions(orderingOptions: OrderingOption[] | null): void {
      localStorage.setItem(this.systemLogOrderingOptionsStorageKey, JSON.stringify(orderingOptions));
   }
}
